import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Inject,
} from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from '@angular/forms';
import { ConfigService } from '../../../services/application/config.service.';
import moment from 'moment';
import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
import { AuthService } from '../../../services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { LoadService } from '../../../services/application/load.service';
import { Title } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import {
    CaptchaService,
    ICaptcha,
} from 'src/app/services/captcha/captcha.service';
import {
    trigger,
    state,
    style,
    transition,
    animate,
} from '@angular/animations';

@Component({
    selector: 'app-recovery',
    templateUrl: './recovery.component.html',
    styleUrls: ['./recovery.component.scss'],
    animations: [
        trigger('showOpacityAnimation', [
            state(
                'on',
                style({
                    opacity: 1,
                    visibility: 'visible',
                }),
            ),
            state(
                'off',
                style({
                    opacity: 0,
                    visibility: 'hidden',
                }),
            ),
            transition('void => on', [
                style({ opacity: 0, visibility: 'hidden' }),
                animate(
                    '300ms ease-in',
                    style({
                        opacity: 1,
                        visibility: 'visible',
                    }),
                ),
            ]),
            transition('on => off', [
                animate(
                    '300ms ease-out',
                    style({
                        opacity: 0,
                        visibility: 'hidden',
                    }),
                ),
            ]),
        ]),
    ],
})
export class RecoveryComponent implements OnInit {
    @Input() AccessReg: boolean = false;
    animState = 'on';
    loading = false;
    recoveryForm!: FormGroup;
    newPasswordForm!: FormGroup;
    captchaImage = '';
    maxDate!: string;
    private recoveryToken: string | null = null;
    isTokenRecovery: boolean = false;
    private pageSetting: any;
    captcha: ICaptcha | undefined = undefined;
    // frmReg!: FormGroup;
    newPassHidden: boolean = false;
    newPassHiddenConfirm: boolean = false;

    @Output() onChanged = new EventEmitter<number>();
    @Output() onError = new EventEmitter<string>();

    constructor(
        private configService: ConfigService,
        private authService: AuthService,
        private alertService: AlertService,
        private loadService: LoadService,
        private captchaService: CaptchaService,
        @Inject(APP_BASE_HREF) private baseHref: string,
        private titleService: Title,
    ) {
        this.pageSetting = loadService.configData.pages.recovery;
        if (this.pageSetting && this.pageSetting.title) {
            this.titleService.setTitle(this.pageSetting.title);
        }

        const recoveryPath = `${baseHref}login/recovery`;
        this.recoveryToken = location.pathname.substring(recoveryPath.length);
        this.recoveryToken = this.recoveryToken.substring(1);
        if (!this.recoveryToken) {
            this.isTokenRecovery = true;
        }
    }

    ngOnInit(): void {
        this.maxDate = moment(new Date()).format('YYYY-MM-DD');
        this.initializeForms();

        this.getCaptcha();
    }

    private initializeForms(): void {
        // Валидатор для сравнения паролей
        const passwordMatchValidator = (
            control: AbstractControl,
        ): ValidationErrors | null => {
            const newPassword = control.get('newPW')?.value;
            const confirmPassword = control.get('newPW2')?.value;

            // Проверяем, что оба поля заполнены
            if (!newPassword || !confirmPassword) {
                return null; // Не показываем ошибку, если одно из полей пустое
            }

            return newPassword === confirmPassword
                ? null
                : { passwordMismatch: true };
        };
        this.recoveryForm = new FormGroup({
            captcha: new FormControl('', [
                Validators.minLength(4),
                Validators.maxLength(4),
            ]),
            lastName: new FormControl('', [Validators.minLength(3)]),
            firstName: new FormControl('', [Validators.minLength(3)]),
            secondName: new FormControl('', [Validators.minLength(1)]),
            birthDate: new FormControl('', [Validators.minLength(1)]),
            email: new FormControl('', [Validators.email]),
        });

        // this.newPasswordForm = new FormGroup({
        //     newPW: new FormControl('', [Validators.minLength(3)]),
        //     newPW2: new FormControl('', [Validators.minLength(3)]),
        // });

        this.newPasswordForm = new FormGroup(
            {
                newPW: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                ]),
                newPW2: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                    this.confirmPasswordValidator,
                ]),
            },
            { validators: passwordMatchValidator },
        );

        if (this.isTokenRecovery && this.recoveryToken) {
            this.authService.checktr(this.recoveryToken).subscribe(
                (resultToken) => {
                    if (
                        resultToken &&
                        resultToken[0] &&
                        resultToken[0].err_code == 0
                    ) {
                        this.alertService.info('Успешная проверка токена.');
                    } else {
                        this.recoveryToken = null;
                        this.isTokenRecovery = false;
                        const errorMessage =
                            resultToken &&
                            resultToken[0] &&
                            resultToken[0].err_text &&
                            resultToken[0].err_text.length > 0
                                ? resultToken[0].err_text
                                : 'Error validating token.';
                        this.alertService.error(errorMessage);
                        window.location.href = `${this.baseHref}login`;
                    }
                },
                (err) => {
                    console.error('resultToken=', err);
                },
            );
        }
    }

    public confirmPasswordValidator(
        control: AbstractControl,
    ): ValidationErrors | null {
        const newPassword = control.parent?.get('newPW')?.value;
        const confirmPassword = control.value;

        // Если одно из полей пустое — не показываем ошибку
        if (!newPassword || !confirmPassword) {
            return null;
        }

        return newPassword === confirmPassword
            ? null
            : { passwordMismatch: true };
    }

    public formatDate(event: any): boolean {
        let isValid = true;
        if (event.srcElement.value.length >= 10) {
            let year = moment(
                this.recoveryForm.controls['birthDate'].value,
            ).format('YYYY');
            if (year && year[0] && Number(year[0]) > 0) {
                isValid = false;
            }
        }
        return isValid;
    }

    whenAnimate(event: any) {
        if (event.toState === 'off') {
            this.onChanged.emit(0);
        }
    }

    // Получение капчи
    async getCaptcha() {
        this.loading = true;
        this.captcha = await this.captchaService.fetchCaptcha();
        this.loading = false;
    }

    public refreshCaptcha() {
        // console.log(this.frmReg)
        this.captcha = undefined;

        this.recoveryForm.controls['captcha']?.setValue('');
        this.getCaptcha();
    }

    goAuth(): void {
        this.animState = 'off';
    }

    goRecovery() {
        this.loading = true;
        const formControls = this.recoveryForm.controls;

        this.authService
            .findpatientchangepw(
                formControls['lastName'].value,
                formControls['firstName'].value,
                formControls['secondName'].value,
                formControls['birthDate'].value,
                formControls['email'].value,
                formControls['captcha'].value,
                this.captcha?.id,
                // this.captcha.id ? this.captcha.id.toString() : null
            )
            .subscribe(
                (res) => {
                    this.loading = false;

                    if (!res) {
                        this.handleError(
                            res.err_text ||
                                'Что-то пошло не так, попробуйте позже.',
                        );
                        return;
                    }

                    if (res.identity > 0) {
                        this.handleSuccess();
                    } else {
                        this.handleError(
                            res.err_text ||
                                'Что-то пошло не так, попробуйте позже.',
                        );
                    }
                },
                (error) => {
                    // console.log(error);
                    this.loading = false;
                    this.handleError(
                        error.msg || 'Что-то пошло не так, попробуйте позже.',
                    );
                },
            );
    }

    private handleSuccess() {
        sessionStorage.setItem('recoveryMessage', 'recoveryMessage');
        // this.alertService.info(
        //     'Вам на почту отправлена ссылка для восстанавления пароля.',
        //     9000,
        //     true
        // );
        // setTimeout(() => {
        window.location.href = `${this.baseHref}login`;
        // }, 9000);
        // this.refreshCaptcha();
    }

    private handleError(errorMessage: string) {
        this.refreshCaptcha();
        this.alertService.error('Ошибка: ' + errorMessage);
    }

    goRecoveryNewPW() {
        this.loading = true;

        const { newPW, newPW2 } = this.newPasswordForm?.controls;
        const isNewPwReentered =
            newPW?.value && newPW2?.value && newPW2?.value === newPW?.value;
        const isChangeValid = this.recoveryToken && this.newPasswordForm;

        if (isChangeValid && isNewPwReentered) {
            this.authService
                .changepwtoken(
                    this.recoveryToken!,
                    this.newPasswordForm.controls['newPW'].value,
                )
                .subscribe(
                    (res) => {
                        if (res && res.err_code > 0) {
                            this.alertService.error('Error: ' + res.err_text);
                            this.loading = false;
                        } else {
                            this.alertService.info(
                                'Пароль успешно изменен.',
                                9000,
                            );
                            setTimeout(() => {
                                window.location.href = `${this.baseHref}login`;
                            }, 5000);
                        }
                    },
                    (err) => {
                        this.loading = false;
                        this.alertService.error(
                            err.msg ||
                                'Ошибка изменения пароля, попробуйте позже.',
                        );
                    },
                );
        } else {
            this.alertService.error('Пароли не совпадают.');
            this.loading = false;
        }
    }

    isCopyPassword(): boolean {
        return (
            this.newPasswordForm &&
            this.newPasswordForm.controls['newPW'] &&
            this.newPasswordForm.controls['newPW'].value &&
            this.newPasswordForm.controls['newPW2'] &&
            this.newPasswordForm.controls['newPW2'].value &&
            this.newPasswordForm.controls['newPW'].value ===
                this.newPasswordForm.controls['newPW2'].value
        );
    }

    public numberOnly(event: any): boolean {
        // Проверяем длину значения в поле
        if (
            event.target.value.length >= 4 &&
            event.keyCode !== 8 &&
            event.keyCode !== 46
        ) {
            return false;
        }

        const charCode = event.which ? event.which : event.keyCode;

        // Разрешаем клавиши удаления (backspace, delete)
        if (charCode === 8 || charCode === 46) {
            return true;
        }

        // Запрет ввода нуля в начале
        if (charCode === 48 && event.target.value.length === 0) {
            return false;
        }

        // Разрешаем только цифры (коды 48-57)
        return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }

    newPassHiddenHandler() {
        this.newPassHidden = !this.newPassHidden;
    }
    newPassHiddenHandlerConfirm() {
        this.newPassHiddenConfirm = !this.newPassHiddenConfirm;
    }
}
